/**
 * E&E Trading — Manufacturer CofC Cart Handler
 * File: assets/ee-cofc.js
 */

(function () {
  'use strict';

  function initCofC() {
    const checkboxes = document.querySelectorAll('.ee-cofc__checkbox');
    if (!checkboxes.length) return;
    syncCheckboxWithCart(checkboxes);
    // No change listener — CofC added only when Add to Cart or Add to Bulk Order is clicked
  }

  function syncCheckboxWithCart(checkboxes) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        checkboxes.forEach(function(checkbox) {
          const variantId = parseInt(checkbox.getAttribute('data-variant-id'));
          const productId = checkbox.getAttribute('data-product-id');
          checkbox.checked = cart.items.some(function(i) {
            return i.variant_id === variantId && i.properties && i.properties['cofc_product_id'] === productId;
          });
        });
      });
  }

  // Called by Add to Cart button handler or bulk add
  function addCofCToCart(checkbox, selectedVariantId, callback) {
    const variantId = parseInt(checkbox.getAttribute('data-variant-id'));
    const productId = checkbox.getAttribute('data-product-id');
    const partNumber = checkbox.getAttribute('data-part-number');

    // Fetch selected variant info
    var skuPromise = selectedVariantId
      ? fetch('/variants/' + selectedVariantId + '.js')
          .then(function(r) { return r.json(); })
          .then(function(v) {
            return {
              sku: v.sku || checkbox.getAttribute('data-sku'),
              title: v.title || '',
              productTitle: document.querySelector('h1.product-title, h1[class*="product"], .product-title h1')
                ? document.querySelector('h1.product-title, h1[class*="product"], .product-title h1').textContent.trim()
                : partNumber
            };
          })
          .catch(function() { return { sku: checkbox.getAttribute('data-sku'), title: '', productTitle: partNumber }; })
      : Promise.resolve({ sku: checkbox.getAttribute('data-sku'), title: '', productTitle: partNumber });

    skuPromise.then(function(info) {
      var selectedSku = info.sku;
      var forValue = info.productTitle;
      if (info.title) forValue += ' — ' + info.title;
      forValue += ' (' + selectedSku + ')';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            'For': forValue,
            'cofc_product_id': productId,
            'SKU': 'MFGCOFC-' + selectedSku,
            '_cofc_sku': selectedSku
          }
        })
      })
      .then(function(res) { if (!res.ok) throw new Error('Failed'); return res.json(); })
      .then(function() {
        if (callback) {
          callback();
        } else {
          // Update bubble count directly
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            var itemCount = cart.item_count;

            // Fix cart bubble — remove visually-hidden class and set count
            function fixBubble() {
              var bubble = document.querySelector('.cart-bubble');
              if (bubble) {
                bubble.classList.remove('visually-hidden');
                var countEl = bubble.querySelector('[class*="count"], span');
                if (countEl) countEl.textContent = itemCount;
                else bubble.textContent = itemCount;
              }
            }

            // Refresh cart drawer
            var p = Promise.resolve(cart);
            var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
            ev.promise = p;
            document.dispatchEvent(ev);

            // Fix bubble after Horizon re-renders
            setTimeout(fixBubble, 300);
            setTimeout(fixBubble, 800);
          });
        }
      })
      .catch(function(err) {
        console.error('CofC add error:', err);
      });
    });
  }

  // Hook into Add to Cart button — intercept click, not submit
        function hookAddToCartButton() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      if (form.dataset.cofcHooked) return;
      form.dataset.cofcHooked = '1';

      form.addEventListener('submit', function(e) {
        var container = form.closest('.product-form, [data-product-form], section, .shopify-section');
        var checkbox = container
          ? (container.querySelector('.ee-cofc__checkbox') || document.querySelector('.ee-cofc__checkbox'))
          : document.querySelector('.ee-cofc__checkbox');

        if (!checkbox || !checkbox.checked) return;

        var bulkCartItems = [];
        try { bulkCartItems = JSON.parse(localStorage.getItem('ee_bulk_cart') || '[]'); } catch(ex) {}
        if (bulkCartItems.length > 0) return;

        e.preventDefault();
        e.stopPropagation();

        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var selectedVariantId = variantInput ? parseInt(variantInput.value) : null;
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: selectedVariantId, quantity: qty }]
          })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          var cofcVariantId = parseInt(checkbox.getAttribute('data-variant-id'));
          var productId = checkbox.getAttribute('data-product-id');
          var partNumber = checkbox.getAttribute('data-part-number');

          return fetch('/variants/' + selectedVariantId + '.js')
            .then(function(r) { return r.json(); })
            .then(function(v) {
              var selectedSku = v.sku || checkbox.getAttribute('data-sku');
              var titleEl = document.querySelector('h1.product-title, h1[class*="product"], .product-title h1');
              var productTitle = titleEl ? titleEl.textContent.trim() : partNumber;
              var forValue = productTitle + (v.title ? ' — ' + v.title : '') + ' (' + selectedSku + ')';

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{
                    id: cofcVariantId,
                    quantity: 1,
                    properties: {
                      'For': forValue,
                      'cofc_product_id': productId,
                      'SKU': 'MFGCOFC-' + selectedSku,
                      '_cofc_sku': selectedSku
                    }
                  }]
                })
              });
            });
        })
        .then(function() {
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            var p = Promise.resolve(cart);
            var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
            ev.promise = p;
            document.dispatchEvent(ev);
          });
        })
        .catch(function(err) { console.error('Add to cart error:', err); });
      }, true);
    });
  }
  // Watch for cart changes — when a product is removed, remove its paired CofC
  var _removingOrphan = false;
  function removeOrphanCofCsFromCart() {
    if (_removingOrphan) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items) return;
        var cofcItems = cart.items.filter(function(i) {
          return i.properties && i.properties['cofc_product_id'];
        });
        if (!cofcItems.length) return;
        var toRemove = [];
        cofcItems.forEach(function(cofc, idx) {
          var cofcSku = cofc.properties['_cofc_sku'] || '';
          if (!cofcSku) return;
          var productExists = cart.items.some(function(i) {
            return i.sku === cofcSku && !i.properties['cofc_product_id'];
          });
          if (!productExists) {
            // Use line number (1-indexed) to remove
            var lineNum = cart.items.indexOf(cofc) + 1;
            toRemove.push(lineNum);
          }
        });
        if (!toRemove.length) return;
        _removingOrphan = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: toRemove[0], quantity: 0 })
        }).then(function() {
          _removingOrphan = false;
          // Refresh cart drawer
          var p = fetch('/cart.js').then(function(r){return r.json();});
          var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          ev.promise = p;
          document.dispatchEvent(ev);
        }).catch(function(){ _removingOrphan = false; });
      });
  }

  var _orphanCheckTimer = null;
  function debouncedOrphanCheck() {
    if (_orphanCheckTimer) clearTimeout(_orphanCheckTimer);
    _orphanCheckTimer = setTimeout(function() {
      _orphanCheckTimer = null;
      removeOrphanCofCsFromCart();
    }, 1500);
  }

  function watchCartRemovals() {
    var origFetch = window.fetch;
    window.fetch = function(url, options) {
      var result = origFetch.apply(this, arguments);
      // Only trigger orphan check for Horizon's cart changes, not ours
      if (typeof url === 'string' && url.indexOf('/cart/change') !== -1 && !_removingOrphan) {
        result.then(function() { debouncedOrphanCheck(); }).catch(function(){});
      }
      return result;
    };
  }

  // Public API for bulk cart to call
  window.EE_CofC = {
    addToCart: addCofCToCart
  };

  // Watch for cart line item deletions and remove orphan CofC
  document.addEventListener('shopify:cart:lines-update', function(e) {
    if (e.promise) {
      e.promise.then(function(result) {
        var cart = result && result.detail ? result.detail : result;
        if (!cart || !cart.items) return;
        // Find CofC items in cart
        var cofcItems = cart.items.filter(function(i) {
          return i.properties && i.properties['cofc_product_id'];
        });
        if (!cofcItems.length) return;
        // Check each CofC — if its paired product is gone, remove the CofC
        cofcItems.forEach(function(cofc) {
          var productId = cofc.properties['cofc_product_id'];
          var hasProduct = cart.items.some(function(i) {
            return i.properties && i.properties['cofc_product_id'] === undefined &&
                   String(i.product_id) === String(productId);
          });
          if (!hasProduct) {
            // Remove orphan CofC
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: cofc.variant_id, quantity: 0 })
            }).catch(function(){});
          }
        });
      }).catch(function(){});
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initCofC(); hookAddToCartButton(); watchCartRemovals(); });
  } else {
    initCofC();
    hookAddToCartButton();
    watchCartRemovals();
  }
})();
